import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import * as s from "./Divider.module.scss";

type DividerProps = {
	variant: "horizontal" | "vertical" | "image" | "responsive";
	className?: string;
};

/**
 * This is a general style for the divider. Add a class name to position it.
 */
const Divider: FC<DividerProps> = ({ variant, className }) => {
	return <hr className={cn(s[variant], className)} />;
};

export default Divider;
